import { render, staticRenderFns } from "./ColorCheckout.vue?vue&type=template&id=4630cf4e"
import script from "./ColorCheckout.vue?vue&type=script&lang=js"
export * from "./ColorCheckout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports